module.exports = __webpack_public_path__ + "img/avatar-vip.fc4bd71b.png";